import Button from '../Button';
import { Text } from '../typography';
import styles from './TablePageLayout.module.scss';
import { keys } from '../../utilities/translator/translation_keys';
import { useTranslation } from 'react-i18next';
import SimpleTabSystem from '../SimpleTabSystem';

export default function TablePageLayout({
  header,
  buttonProps = {},
  table,
  tabProps = {},
}) {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Text size="lg" weight="bold" noMargin>
          {header}
        </Text>
        <Button {...buttonProps} value={t(keys.common.NEW)} icon="add" />
      </div>
      {!!tabProps && (
        <div className={styles.tabs}>
          <SimpleTabSystem {...tabProps} />
        </div>
      )}
      {table}
    </div>
  );
}
